import React from "react";
import GAAddMembersToGroupContainer from "../../modules/GAGroups/containers/GAAddMembersToGroupContainer/GAAddMembersToGroupContainer";

const GAAddMembersToGroup = () => {
  return <GAAddMembersToGroupContainer />;
};

export default GAAddMembersToGroup;

